export default __webpack_public_path__ + "8117a74bdf88e9143471800daf9581b8.png";